import React, { useEffect, useState } from "react";
import Setting from "src/components/Layout/Setting";
import { useAppState } from "src/contexts/AppContext";

// Холбогдох цагийн хуваарь
const WORK_HOURS = [
  { from: "08:00", to: "12:00" },
  { from: "14:00", to: "18:00" },
];

// Хуваарийг Улаанбаатарын цагаар тооцно (төхөөрөмжийн цагийн бүсээс хамаарахгүй)
const UB_TZ = "Asia/Ulaanbaatar";
const WEEKDAY_KEYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];

const toMinutes = (hhmm) => {
  const [h, m] = hhmm.split(":").map(Number);
  return h * 60 + m;
};

// Улаанбаатарын одоогийн гараг ба минут
const ubNow = () => {
  const now = new Date();
  try {
    const parts = new Intl.DateTimeFormat("en-US", {
      timeZone: UB_TZ,
      weekday: "short",
      hour: "2-digit",
      minute: "2-digit",
      hour12: false,
    }).formatToParts(now);
    const pick = (type) => parts.find((p) => p.type === type)?.value;
    const hour = Number(pick("hour")) % 24;
    const minute = Number(pick("minute"));
    if (Number.isNaN(hour) || Number.isNaN(minute))
      throw new Error("bad parts");
    return { weekday: pick("weekday"), minutes: hour * 60 + minute };
  } catch (e) {
    // Хөтөч цагийн бүсийг дэмжихгүй бол төхөөрөмжийн цагаар
    return {
      weekday: WEEKDAY_KEYS[now.getDay()],
      minutes: now.getHours() * 60 + now.getMinutes(),
    };
  }
};

// Одоо холбогдох цаг дээр байгаа эсэх (Ажлын өдөр + цагийн хуваарь)
const isWithinWorkHours = () => {
  const { weekday, minutes } = ubNow();
  if (weekday === "Sat" || weekday === "Sun") return false;
  return WORK_HOURS.some(
    (s) => minutes >= toMinutes(s.from) && minutes < toMinutes(s.to),
  );
};

// Header-ийн зүүн талын товчнуудын responsive хэв маяг
const HEADER_CSS = `
.main-header-left{min-width:0;}
.header-megamenu-dropdown.nav{display:flex;align-items:center;flex-wrap:nowrap;
  margin-bottom:0;min-width:0;}
.header-megamenu-dropdown.nav > .nav-item{flex:0 0 auto;}
.main-header-right .nav{flex-wrap:nowrap;}
.hdr-nav-item{display:flex;align-items:center;margin-left:10px;}
.hdr-chip{display:inline-flex;align-items:center;gap:7px;height:34px;
  padding:0 12px;background:#fff;border:0;border-radius:9px;
  box-shadow:0 2px 6px rgba(16,24,40,.16);color:#1f2937;
  font-size:12.5px;font-weight:600;line-height:1;white-space:nowrap;
  text-decoration:none;cursor:pointer;
  transition:box-shadow .15s,transform .15s,color .15s;}
.hdr-chip:hover,.hdr-chip:focus{color:#10456b;text-decoration:none;outline:none;
  box-shadow:0 4px 12px rgba(16,24,40,.22);transform:translateY(-1px);}
.hdr-chip-logo{width:45px;height:13px;flex:0 0 auto;object-fit:contain;}
.hdr-chip > i{font-size:15px;margin-right:0;line-height:1;}
.hdr-mm-btn{display:flex;align-items:center;gap:6px;padding:8px 16px;
  line-height:1;white-space:nowrap;}
.hdr-mm-btn > i{margin-right:0;}

@media (max-width:991px){
  .hdr-nav-item{margin-left:8px;}
  .hdr-chip{padding:0 10px;font-size:12px;}
  .hdr-mm-btn{padding:7px 10px;}
}
/* Утсан дэлгэц: зөвхөн icon/лого — текст нуугдана, мөр таслахгүй */
@media (max-width:767px){
  .main-header > .container-fluid{padding-left:10px;padding-right:10px;}
  .hdr-nav-item{margin-left:5px;}
  .hdr-chip-text,.hdr-mm-text{display:none !important;}
  .hdr-chip{height:32px;padding:0 9px;gap:0;}
  .hdr-mm-btn{padding:5px 6px;gap:0;}
  .hdr-mm-btn.dropdown-toggle::after{display:none;}
  .hdr-chip > i{font-size:16px;}
  /* баруун талын icon-ууд ч жижигрэн, нэг мөрөнд багтана */
  .main-header-right .main-header-message > a,
  .main-header-right .nav-item > a.nav-link{padding:.35rem .2rem !important;}
  .main-header-right .main-header-message i,
  .main-header-right .nav-item i{height:34px;width:34px;line-height:34px;
    font-size:16px;}
}
@media (max-width:400px){
  .hdr-nav-item{margin-left:4px;}
  .hdr-chip{padding:0 7px;}
  .hdr-chip-logo{width:38px;height:11px;}
  .main-header-right .main-header-message i,
  .main-header-right .nav-item i{height:32px;width:32px;line-height:32px;}
}
`;

// Modal-ийн өөрийн хэв маяг (theme CSS-ээс хамааралгүй байх зорилгоор)
const ERP_MODAL_CSS = `
.erp-backdrop{position:fixed;inset:0;background:rgba(15,23,42,.55);
  backdrop-filter:blur(2px);z-index:1050;animation:erpFade .18s ease-out;}
.erp-modal{position:fixed;inset:0;z-index:1055;overflow-y:auto;
  display:flex;align-items:flex-start;justify-content:center;padding:24px 16px;}
.erp-dialog{position:relative;width:100%;max-width:1100px;margin:auto;
  background:#fff;border-radius:14px;overflow:hidden;
  box-shadow:0 24px 60px rgba(15,23,42,.28);
  animation:erpUp .22s cubic-bezier(.2,.8,.2,1);
  font-family:inherit;color:#1f2937;text-align:left;}
@keyframes erpFade{from{opacity:0}to{opacity:1}}
@keyframes erpUp{from{opacity:0;transform:translateY(14px) scale(.985)}
  to{opacity:1;transform:none}}

/* HEADER */
.erp-head{display:flex;align-items:center;gap:12px;padding:14px 16px;
  background:linear-gradient(135deg,#10456b 0%,#1a7f8e 100%);color:#fff;}
.erp-head-icon{flex:0 0 38px;width:38px;height:38px;border-radius:10px;
  background:rgba(255,255,255,.16);display:flex;align-items:center;
  justify-content:center;font-size:18px;}
.erp-head-text{flex:1 1 auto;min-width:0;}
.erp-title{margin:0;font-size:15px;font-weight:600;line-height:1.3;color:#fff;}
.erp-subtitle{display:block;font-size:11.5px;opacity:.8;margin-top:2px;}
.erp-close{flex:0 0 auto;width:32px;height:32px;border:0;border-radius:8px;
  background:rgba(255,255,255,.14);color:#fff;font-size:16px;line-height:1;
  cursor:pointer;transition:background .15s;}
.erp-close:hover{background:rgba(255,255,255,.3);}

/* ХОЛБОГДОХ ЦАГ */
.erp-hours{display:flex;align-items:center;flex-wrap:wrap;gap:8px 12px;
  padding:9px 16px;background:#fff8ea;border-bottom:1px solid #f2e3c6;}
.erp-hours-label{font-size:12px;font-weight:600;color:#8a5a00;}
.erp-hours-times{display:flex;flex-wrap:wrap;gap:6px;}
.erp-chip{display:inline-block;padding:2px 10px;border-radius:999px;
  background:#fff;border:1px solid #edd39a;color:#7a4f00;
  font-size:12px;font-weight:600;letter-spacing:.2px;white-space:nowrap;}
.erp-hours-tz{font-size:11px;color:#a07a2c;}
.erp-live{display:inline-flex;align-items:center;gap:6px;margin-left:auto;
  padding:2px 10px;border-radius:999px;font-size:11.5px;font-weight:600;
  white-space:nowrap;}
.erp-live .erp-dot{width:7px;height:7px;border-radius:50%;display:inline-block;}
.erp-live-on{background:#e6f7ee;color:#137a4b;}
.erp-live-on .erp-dot{background:#18a15c;box-shadow:0 0 0 3px rgba(24,161,92,.18);}
.erp-live-off{background:#f1f3f6;color:#6b7280;}
.erp-live-off .erp-dot{background:#9aa4b2;}

/* ХАЙЛТ */
.erp-toolbar{display:flex;align-items:center;gap:10px;padding:10px 16px;
  border-bottom:1px solid #eef1f5;background:#fff;}
.erp-search{position:relative;flex:1 1 auto;max-width:380px;}
.erp-search > i{position:absolute;left:10px;top:50%;transform:translateY(-50%);
  color:#9aa4b2;font-size:14px;pointer-events:none;}
.erp-search input{width:100%;height:34px;padding:0 30px 0 30px;
  border:1px solid #dfe5ec;border-radius:8px;background:#fbfcfe;
  font-size:12.5px;color:#1f2937;outline:none;transition:border .15s,box-shadow .15s;}
.erp-search input:focus{border-color:#1a7f8e;background:#fff;
  box-shadow:0 0 0 3px rgba(26,127,142,.12);}
.erp-search-clear{position:absolute;right:4px;top:50%;transform:translateY(-50%);
  width:24px;height:24px;border:0;border-radius:6px;background:transparent;
  color:#9aa4b2;cursor:pointer;font-size:13px;line-height:1;}
.erp-search-clear:hover{background:#eef1f5;color:#475569;}
.erp-count{flex:0 0 auto;font-size:11.5px;color:#8a94a6;font-weight:600;}

/* BODY */
.erp-body{max-height:calc(100vh - 300px);min-height:120px;overflow-y:auto;
  -webkit-overflow-scrolling:touch;}
.erp-body::-webkit-scrollbar{width:8px;height:8px;}
.erp-body::-webkit-scrollbar-thumb{background:#d8dee7;border-radius:8px;}
.erp-body::-webkit-scrollbar-thumb:hover{background:#c2cad6;}

/* ХҮСНЭГТ */
.erp-table-wrap{overflow-x:auto;}
/* table-layout:fixed — багана хувиараа тогтож, урт текст мөр тасарна.
   Ингэснээр desktop дээр хэвтээ scroll гарахгүй, И-мэйл багана хальж гарахгүй */
.erp-table{width:100%;min-width:860px;table-layout:fixed;
  border-collapse:separate;border-spacing:0;font-size:12.5px;}
.erp-table thead th{position:sticky;top:0;z-index:2;background:#f5f8fb;
  padding:9px 10px;text-align:left;font-size:10.5px;font-weight:700;
  letter-spacing:.4px;text-transform:uppercase;color:#5b6a80;
  border-bottom:1px solid #e4eaf1;white-space:nowrap;}
.erp-table tbody td{padding:9px 10px;vertical-align:middle;
  border-bottom:1px solid #f1f4f8;line-height:1.45;
  white-space:normal;word-break:break-word;overflow-wrap:break-word;}
.erp-table tbody tr:nth-child(even){background:#fcfdfe;}
.erp-table tbody tr:hover{background:#f2f9fd;}
.erp-table tbody tr:last-child td{border-bottom:0;}
.erp-col-no{width:4%;text-align:center;color:#98a2b3;font-weight:600;}
.erp-table td.erp-col-no{text-align:center;}
.erp-col-module{width:16%;}
.erp-col-dept{width:11%;}
.erp-col-pos{width:20%;}
.erp-col-name{width:12%;}
.erp-col-tel{width:8%;}
.erp-col-mail{width:21%;}
.erp-module{font-weight:600;color:#0f4c5c;}
.erp-name{font-weight:600;color:#1f2937;}
.erp-muted{color:#6b7280;font-size:11.5px;}
.erp-mail{word-break:break-all;}
.erp-na{color:#c9d1dc;}
.erp-badge{display:inline-block;padding:2px 8px;border-radius:6px;
  background:#eef2ff;color:#3f4ea8;font-size:11px;font-weight:600;
  line-height:1.35;white-space:normal;}
.erp-link{color:#136a95;text-decoration:none;font-weight:500;}
.erp-link:hover{color:#0d4f70;text-decoration:underline;}

/* ХООСОН */
.erp-empty{padding:40px 20px;text-align:center;color:#8a94a6;}
.erp-empty > i{font-size:26px;opacity:.5;}
.erp-empty p{margin:8px 0 0;font-size:12.5px;}

/* КАРТ (mobile) */
.erp-cards{display:none;padding:12px;gap:10px;}
.erp-card{border:1px solid #e8edf3;border-radius:10px;padding:10px 12px;
  background:#fff;box-shadow:0 1px 2px rgba(16,24,40,.04);}
.erp-card-top{display:flex;align-items:flex-start;gap:8px;margin-bottom:6px;}
.erp-card-no{flex:0 0 22px;width:22px;height:22px;border-radius:6px;
  background:#f1f5f9;color:#64748b;font-size:11px;font-weight:700;
  display:flex;align-items:center;justify-content:center;}
.erp-card-top .erp-module{font-size:12.5px;line-height:1.35;}
.erp-card-person{display:flex;align-items:center;gap:8px;flex-wrap:wrap;}
.erp-card-pos{margin-top:3px;}
.erp-card-actions{display:flex;flex-wrap:wrap;gap:6px;margin-top:9px;}
.erp-action{display:inline-flex;align-items:center;gap:5px;padding:5px 10px;
  border-radius:8px;background:#f2f9fd;border:1px solid #dceaf4;
  color:#136a95;font-size:12px;font-weight:600;text-decoration:none;}
.erp-action:hover{background:#e4f2fa;color:#0d4f70;text-decoration:none;}
.erp-action-mail{background:#f6f7fb;border-color:#e5e8f2;color:#4b5563;
  max-width:100%;word-break:break-all;}

/* FOOTER */
.erp-foot{display:flex;align-items:center;justify-content:space-between;
  gap:10px;padding:10px 16px;background:#f8fafc;border-top:1px solid #eef1f5;}
.erp-foot-note{font-size:11.5px;color:#8a94a6;}
.erp-btn{padding:6px 18px;border:0;border-radius:8px;background:#10456b;
  color:#fff;font-size:12.5px;font-weight:600;cursor:pointer;
  transition:background .15s;}
.erp-btn:hover{background:#0c3350;}

/* RESPONSIVE */
@media (max-width:991px){
  .erp-table{min-width:820px;}
  .erp-body{max-height:calc(100vh - 290px);}
}
@media (max-width:767px){
  .erp-modal{padding:0;}
  .erp-dialog{max-width:100%;min-height:100vh;border-radius:0;margin:0;}
  .erp-table-wrap{display:none;}
  .erp-cards{display:flex;flex-direction:column;}
  .erp-body{max-height:calc(100vh - 232px);}
  .erp-hours{padding:8px 12px;}
  .erp-hours-tz{display:none;}
  .erp-live{margin-left:0;}
  .erp-head{padding:12px;}
  .erp-toolbar{padding:8px 12px;}
  .erp-search{max-width:none;}
  .erp-count{display:none;}
  .erp-foot{padding:8px 12px;}
  .erp-foot-note{display:none;}
  .erp-btn{width:100%;padding:9px 18px;}
}
@media (max-width:400px){
  .erp-subtitle{display:none;}
  .erp-action{font-size:11.5px;}
}
`;

const erplist = [
  {
    id: 1,
    module: "Бараа материалын захиалга",
    dept: "ҮТХ",
    position: "Автоматжуулалтын мэргэжилтэн",
    name: "Д.Гантулга",
    phone: "71557",
    tel: "99908097",
    email: "gantulga.da@erdenetmc.mn",
  },
  {
    id: 2,
    module: "Худалдан авалтын төлөвлөлт",
    dept: "ХААГ",
    position: "Цахим системийн мэргэжилтэн",
    name: "Г.Пүрэв-ойдов",
    phone: "73710",
    tel: "99902418",
    email: "purev-oidov@erdenetmc.mn",
  },
  {
    id: 3,
    module: "Хүний нөөцийн модуль",
    dept: "ХНЗХ",
    position: "Мэдээллийн систем хариуцсан мэргэжилтэн",
    name: "Д.Идэрбаяр",
    phone: "73953",
    tel: "99931394",
    email: "iderbayar@erdenetmc.mn",
  },
  {
    id: 4,
    module: "Баримт бичгийн модуль",
    dept: "ХНЗХ",
    position: "Цахим албан хэрэг хөтлөлт хариуцсан мэргэжилтэн",
    name: "О.Мөнх-Од",
    phone: "73860",
    tel: "95346772",
    email: "munkhod.o@erdenetmc.mn",
  },
  {
    id: 5,
    module: "Цалингийн модуль",
    dept: "ХМТАЦ",
    position: "ERP хариуцсан мэргэжилтэн",
    name: "Г.Гантуяа",
    phone: "73043",
    tel: "99907425",
    email: "gantuya.g@erdenetmc.mn",
  },
  {
    id: 6,
    module: "Томилолтын модуль",
    dept: "ХМТАЦ",
    position: "ERP хариуцсан мэргэжилтэн",
    name: "Б.Минжбадгар",
    phone: "73048",
    tel: "99551616",
    email: "minjbadgar@erdenetmc.mn",
  },
  {
    id: 7,
    module: "ПОС-ын модуль",
    dept: "ХМТАЦ",
    position: "ERP хариуцсан мэргэжилтэн",
    name: "Н.Сугармаа",
    phone: "73047",
    tel: "99908344",
    email: "sugarmaa@erdenetmc.mn",
  },
  {
    id: 8,
    module: "Эдийн засаг, цаг бүртгэлийн модуль",
    dept: "Эдийн засгийн хэлтэс",
    position: "Хөдөлмөр зохион байгуулалт, нормчлолын мэргэжилтэн",
    name: "Т.Банзрагч",
    phone: "73080",
    tel: "99024114",
    email: "",
  },
  {
    id: 9,
    module: "Эдийн засаг, цаг бүртгэлийн модуль",
    dept: "Эдийн засгийн хэлтэс",
    position: "Хөдөлмөр зохион байгуулалт, нормчлолын мэргэжилтэн",
    name: "П.Отгонбаяр",
    phone: "73585 ",
    tel: "99361111",
    email: "",
  },
  {
    id: 10,
    module: "Томилолт, сургалт, цаг бүртгэлийн модуль",
    dept: "ХМТАЦ",
    position: "Компьютерийн системийн инженер",
    name: "П.Амарбаясгалан",
    phone: "71817",
    tel: "",
    email: "",
  },
  {
    id: 11,
    module: "Томилолт, сургалт, цаг бүртгэлийн модуль",
    dept: "ХМТАЦ",
    position: "Компьютерийн системийн инженер",
    name: "Б.Гоёцэцэг",
    phone: "71091 ",
    tel: "",
    email: "",
  },
];

const Header = () => {
  const [setting, setSetting] = useState(false);
  const { state } = useAppState();
  const [showModal, setShowModal] = useState(false);
  const [query, setQuery] = useState("");
  const [tick, setTick] = useState(0);
  const handleOpen = () => setShowModal(true);
  const handleClose = () => setShowModal(false);

  // ESC дарахад хаах + фон дээрх скролл түгжих + цагийн төлөвийг сэргээх
  useEffect(() => {
    if (!showModal) return undefined;
    const onKeyDown = (e) => {
      if (e.key === "Escape") setShowModal(false);
    };
    document.addEventListener("keydown", onKeyDown);
    document.body.classList.add("modal-open");
    // 30 секунд тутам шалгаж, 12:00/18:00 гэх мэт хил давахад төлөв шинэчлэгдэнэ
    const timer = setInterval(() => setTick((t) => t + 1), 30000);
    return () => {
      document.removeEventListener("keydown", onKeyDown);
      document.body.classList.remove("modal-open");
      clearInterval(timer);
    };
  }, [showModal]);

  const q = query.trim().toLowerCase();
  const filteredList = q
    ? erplist.filter((item) =>
        [
          item.module,
          item.dept,
          item.position,
          item.name,
          item.phone,
          item.tel,
          item.email,
        ]
          .join(" ")
          .toLowerCase()
          .includes(q),
      )
    : erplist;
  // tick — 30 сек тутмын дахин тооцоолол (eslint-д хэрэглэгдэж байгааг мэдүүлэх)
  const workingNow = showModal && tick >= 0 ? isWithinWorkHours() : false;
  ///uihhajshdsajkdhakjshdjkasdha
  // const [searchClicked, setsearchClicked] = useState(false);
  // // const togglesearch = () => {
  // //   setsearchClicked(!searchClicked);
  // // };
  const toggleSetting = (e) => {
    e.preventDefault();
    setSetting(!setting);
  };
  //// push test t

  return (
    <div className="main-header side-header">
      <style>{HEADER_CSS}</style>
      <div className="container-fluid">
        <div className="main-header-left ">
          <div
            className="app-sidebar__toggle mobile-toggle"
            data-toggle="sidebar"
          >
            <a
              className="open-toggle"
              href="/"
              onClick={(e) => e.preventDefault()}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                className="eva eva-menu-outline header-icons"
              >
                <g data-name="Layer 2">
                  <g data-name="menu">
                    <rect
                      width={24}
                      height={24}
                      transform="rotate(180 12 12)"
                      opacity={0}
                    />
                    <rect
                      x={3}
                      y={11}
                      width={18}
                      height={2}
                      rx=".95"
                      ry=".95"
                    />
                    <rect
                      x={3}
                      y={16}
                      width={18}
                      height={2}
                      rx=".95"
                      ry=".95"
                    />
                    <rect x={3} y={6} width={18} height={2} rx=".95" ry=".95" />
                  </g>
                </g>
              </svg>
            </a>{" "}
            <a
              className="close-toggle"
              href="/"
              onClick={(e) => e.preventDefault()}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width={24}
                height={24}
                viewBox="0 0 24 24"
                className="eva eva-close-outline header-icons"
              >
                <g data-name="Layer 2">
                  <g data-name="close">
                    <rect
                      width={24}
                      height={24}
                      transform="rotate(180 12 12)"
                      opacity={0}
                    />
                    <path d="M13.41 12l4.3-4.29a1 1 0 1 0-1.42-1.42L12 10.59l-4.29-4.3a1 1 0 0 0-1.42 1.42l4.3 4.29-4.3 4.29a1 1 0 0 0 0 1.42 1 1 0 0 0 1.42 0l4.29-4.3 4.29 4.3a1 1 0 0 0 1.42 0 1 1 0 0 0 0-1.42z" />
                  </g>
                </g>
              </svg>
            </a>
          </div>
          <ul className="header-megamenu-dropdown  nav">
            <li
              className="nav-item"
              style={{
                display: "flex",
              }}
            >
              <div className="btn-group dropdown">
                <button
                  aria-expanded="false"
                  aria-haspopup="true"
                  className="btn btn-link dropdown-toggle hdr-mm-btn"
                  data-toggle="dropdown"
                  id="dropdownMenuButton2"
                  type="button"
                  title="Видео хурал"
                >
                  <i className="fe fe-camera"></i>
                  <span className="hdr-mm-text">Видео хурал</span>
                </button>
                <div className="dropdown-menu">
                  <div className="">
                    <div>
                      <div className="setting-menu ">
                        <a
                          className="dropdown-item"
                          href="https://us02web.zoom.us/j/81792001211"
                        >
                          <i className="mdi mdi-account-outline tx-16 mr-2 mt-1"></i>
                          Ерөнхий захирлын шуурхай
                        </a>
                        <a
                          className="dropdown-item"
                          href="https://us02web.zoom.us/j/87178798694#success"
                        >
                          <i className="mdi mdi-account-box-outline tx-16 mr-2"></i>
                          Үйлдвэрийн бүтцийн нэгжүүдийн өргөтгөсөн шуурхай
                        </a>
                        {/* <a
                          className="dropdown-item"
                          href="https://erdenetmc-mn.zoom.us/j/86245871013?pwd=U2p3em93anN4Ui9CYm1KYTdXZmtjdz09"
                        >
                          <i className="mdi mdi-account-box-outline tx-16 mr-2"></i>
                          Их зогсолтын бэлтгэл ажлын хурал
                        </a> */}
                        <a
                          className="dropdown-item"
                          href="https://web.erdenetmc.mn/link/conference"
                        >
                          <i className="mdi mdi-account-location tx-16 mr-2"></i>
                          Бүтцийн нэгжүүдийн дотоод шуурхай
                        </a>
                        {/* <a
                          className="dropdown-item"
                          href="https://erdenetmc-mn.zoom.us/j/89812921508?pwd=YnNFL2ZQb0FqTlF0OXhPRHRmanc2QT09"
                        >
                          <i className="mdi mdi-account-box-outline tx-16 mr-2"></i>
                          Нэн түрүүнд ХЭМАБ-2023 бага хурал
                        </a> */}
                        <a
                          className="dropdown-item"
                          href="https://erdenetmc-mn.zoom.us/j/89477661533?pwd=UHAxcHhqNE9Sc1lmaEwwSGlyaU0xdz09"
                        >
                          <i className="mdi mdi-account-box-outline tx-16 mr-2"></i>
                          Үйл ажиллагааны тайлангийн хурал
                        </a>
                        <a
                          className="dropdown-item"
                          href="https://erdenetmc-mn.zoom.us/j/84919666781?pwd=cmJUSkxpcXVnVk5BMW5rajFNR01ydz09"
                        >
                          <i className="mdi mdi-account-box-outline tx-16 mr-2"></i>
                          Их зогсолтын ажлын хэсгийн хурал
                        </a>
                        <a
                          className="dropdown-item"
                          href="https://us06web.zoom.us/j/89717460099?pwd=7nuJMQd1izUOqqQoi9bqKWb9ZbFaBq.1"
                        >
                          <i className="mdi mdi-account-box-outline tx-16 mr-2"></i>
                          Төлөвлөгөө хэлэлцэх болон сар хаалтын хурал.
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </li>
            <li
              className="nav-item"
              style={{
                display: "flex",
              }}
            >
              <div className="dropdown-menu-rounded btn-group dropdown">
                <button
                  aria-expanded="false"
                  aria-haspopup="true"
                  className="btn btn-link dropdown-toggle hdr-mm-btn"
                  data-toggle="dropdown"
                  id="dropdownMenuButton3"
                  type="button"
                  title="Холбоосууд"
                >
                  <i className="nav-link-icon fe fe-briefcase"></i>
                  <span className="hdr-mm-text">Холбоосууд</span>
                </button>
                <div
                  className="dropdown-menu-lg dropdown-menu"
                  x-placement="bottom-left"
                >
                  <a
                    href="https://erdenetmc.mn/"
                    className="dropdown-item  mt-2"
                    target="_blank"
                    rel="noreferrer"
                  >
                    <i className="dropdown-icon"></i>Эрдэнэт үйлдвэр ТӨҮГ
                  </a>
                  <a
                    className="dropdown-item"
                    href="https://www.erdenettoday.mn"
                  >
                    <i className="dropdown-icon"></i>Өнөөгийн эрдэнэт
                  </a>
                  <a
                    className="dropdown-item"
                    href="https://spellcheck.erdenetmc.mn"
                  >
                    <i className="dropdown-icon"></i>Зөв бичгийн алдаа шалгуур
                  </a>
                  <a
                    className="dropdown-item"
                    href="https://erdenetmcbus.notion.site/2d253b220f1081deb5d6e31d77fe08ac"
                    target="_blank"
                  >
                    <i className="dropdown-icon"></i>“Эрдэнэт үйлдвэр” ТӨҮГ-ын
                    автобусны маршрут
                  </a>
                  <a className="dropdown-item" href="../download/AnyDesk.exe">
                    <i className="dropdown-icon"></i>Anydesk татах
                  </a>
                  <a
                    className="dropdown-item"
                    href="http://papercutserver.erdenetmc.mn:9191/"
                  >
                    <i className="dropdown-icon"></i>Нийтийн принтер
                  </a>
                  <a
                    className="dropdown-item"
                    href="http://papercutserver.erdenetmc.mn:9163/setup"
                  >
                    <i className="dropdown-icon"></i>Принтер setup татах
                  </a>
                  <div className="dropdown-divider"></div>
                </div>
              </div>
            </li>
            <li className="nav-item hdr-nav-item">
              <a
                rel="noreferrer"
                className="hdr-chip"
                href="https://odoo.erdenetmc.mn/"
                title="ERP систем"
              >
                <img
                  src="/img/odoo_logo_small.png"
                  alt="Odoo ERP"
                  className="hdr-chip-logo"
                />
                <span className="hdr-chip-text">ERP систем</span>
              </a>
            </li>
            <li className="nav-item hdr-nav-item">
              <button
                type="button"
                onClick={handleOpen}
                className="hdr-chip"
                title="ERP системийн заавар, утас"
              >
                <i className="fe fe-phone-call"></i>
                <span className="hdr-chip-text">
                  ERP системийн заавар, утас
                </span>
              </button>
            </li>
          </ul>
        </div>
        {showModal && (
          <>
            <style>{ERP_MODAL_CSS}</style>

            {/* BACKDROP */}
            <div className="erp-backdrop" onClick={handleClose}></div>

            {/* MODAL */}
            <div
              className="erp-modal"
              tabIndex="-1"
              role="dialog"
              aria-modal="true"
              aria-label="ERP системийн зөвлөгөө өгөх мэргэжилтнүүдийн мэдээлэл"
              onClick={handleClose} // гадна хэсэг дарахад хаагдана
            >
              <div
                className="erp-dialog"
                onClick={(e) => e.stopPropagation()} // modal дээр дарахад хаагдахгүй
              >
                {/* HEADER */}
                <div className="erp-head">
                  <div className="erp-head-icon">
                    <i className="fe fe-headphones"></i>
                  </div>
                  <div className="erp-head-text">
                    <h6 className="erp-title">
                      ERP системийн зөвлөгөө өгөх мэргэжилтнүүд
                    </h6>
                    <span className="erp-subtitle">
                      Модуль тус бүрээр хариуцсан мэргэжилтэнтэй холбогдоно уу
                    </span>
                  </div>
                  <button
                    type="button"
                    className="erp-close"
                    aria-label="Хаах"
                    onClick={handleClose}
                  >
                    <i className="fe fe-x"></i>
                  </button>
                </div>

                {/* ХОЛБОГДОХ ЦАГ */}
                <div className="erp-hours">
                  <span className="erp-hours-label">
                    <i className="fe fe-clock"></i> Холбогдох цаг
                  </span>
                  <span className="erp-hours-times">
                    {WORK_HOURS.map((s) => (
                      <span className="erp-chip" key={s.from}>
                        {s.from} – {s.to}
                      </span>
                    ))}
                  </span>
                  <span className="erp-hours-tz">Дав–Баа</span>
                  <span
                    className={
                      workingNow
                        ? "erp-live erp-live-on"
                        : "erp-live erp-live-off"
                    }
                    title="Улаанбаатарын цагаар тооцов"
                  >
                    <i className="erp-dot"></i>
                    {workingNow
                      ? "Одоо холбогдох боломжтой"
                      : "Одоо ажлын цаг бус"}
                  </span>
                </div>

                {/* ХАЙЛТ */}
                <div className="erp-toolbar">
                  <div className="erp-search">
                    <i className="fe fe-search"></i>
                    <input
                      type="text"
                      value={query}
                      autoFocus
                      onChange={(e) => setQuery(e.target.value)}
                      placeholder="Модуль, нэгж, нэр, утсаар хайх..."
                    />
                    {query && (
                      <button
                        type="button"
                        className="erp-search-clear"
                        aria-label="Хайлт цэвэрлэх"
                        onClick={() => setQuery("")}
                      >
                        <i className="fe fe-x"></i>
                      </button>
                    )}
                  </div>
                  <span className="erp-count">
                    {filteredList.length} / {erplist.length}
                  </span>
                </div>

                {/* BODY */}
                <div className="erp-body">
                  {filteredList.length === 0 ? (
                    <div className="erp-empty">
                      <i className="fe fe-search"></i>
                      <p>
                        „{query}“ гэсэн хайлтад тохирох мэргэжилтэн олдсонгүй
                      </p>
                    </div>
                  ) : (
                    <>
                      {/* ХҮСНЭГТ — desktop / tablet */}
                      <div className="erp-table-wrap">
                        <table className="erp-table">
                          <thead>
                            <tr>
                              <th className="erp-col-no">№</th>
                              <th className="erp-col-module">Модуль</th>
                              <th className="erp-col-dept">Нэгж</th>
                              <th className="erp-col-pos">Албан тушаал</th>
                              <th className="erp-col-name">Нэр</th>
                              <th className="erp-col-tel">Утас</th>
                              <th className="erp-col-tel">Гар</th>
                              <th className="erp-col-mail">И-мэйл</th>
                            </tr>
                          </thead>
                          <tbody>
                            {filteredList.map((item) => (
                              <tr key={item.id}>
                                <td className="erp-col-no">{item.id}</td>
                                <td className="erp-module">{item.module}</td>
                                <td>
                                  <span className="erp-badge">{item.dept}</span>
                                </td>
                                <td className="erp-muted">{item.position}</td>
                                <td className="erp-name">{item.name}</td>
                                <td>
                                  {item.phone ? (
                                    <a
                                      className="erp-link"
                                      href={`tel:${item.phone.trim()}`}
                                    >
                                      {item.phone}
                                    </a>
                                  ) : (
                                    <span className="erp-na">—</span>
                                  )}
                                </td>
                                <td>
                                  {item.tel ? (
                                    <a
                                      className="erp-link"
                                      href={`tel:${item.tel.trim()}`}
                                    >
                                      {item.tel}
                                    </a>
                                  ) : (
                                    <span className="erp-na">—</span>
                                  )}
                                </td>
                                <td className="erp-mail">
                                  {item.email ? (
                                    <a
                                      className="erp-link"
                                      href={`mailto:${item.email.trim()}`}
                                    >
                                      {item.email}
                                    </a>
                                  ) : (
                                    <span className="erp-na">—</span>
                                  )}
                                </td>
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {/* КАРТ — mobile */}
                      <div className="erp-cards">
                        {filteredList.map((item) => (
                          <div className="erp-card" key={item.id}>
                            <div className="erp-card-top">
                              <span className="erp-card-no">{item.id}</span>
                              <span className="erp-module">{item.module}</span>
                            </div>
                            <div className="erp-card-person">
                              <span className="erp-name">{item.name}</span>
                              <span className="erp-badge">{item.dept}</span>
                            </div>
                            <div className="erp-muted erp-card-pos">
                              {item.position}
                            </div>
                            <div className="erp-card-actions">
                              {item.phone && (
                                <a
                                  className="erp-action"
                                  href={`tel:${item.phone.trim()}`}
                                >
                                  <i className="fe fe-phone"></i>
                                  {item.phone}
                                </a>
                              )}
                              {item.tel && (
                                <a
                                  className="erp-action"
                                  href={`tel:${item.tel.trim()}`}
                                >
                                  <i className="fe fe-smartphone"></i>
                                  {item.tel}
                                </a>
                              )}
                              {item.email && (
                                <a
                                  className="erp-action erp-action-mail"
                                  href={`mailto:${item.email.trim()}`}
                                >
                                  <i className="fe fe-mail"></i>
                                  {item.email}
                                </a>
                              )}
                            </div>
                          </div>
                        ))}
                      </div>
                    </>
                  )}
                </div>

                {/* FOOTER */}
                <div className="erp-foot">
                  <span className="erp-foot-note">
                    <i className="fe fe-info"></i> Утас, и-мэйл дээр дарж шууд
                    холбогдоно
                  </span>
                  <button
                    type="button"
                    className="erp-btn"
                    onClick={handleClose}
                  >
                    Хаах
                  </button>
                </div>
              </div>
            </div>
          </>
        )}
        <div className="main-header-right">
          <div className="nav nav-item  navbar-nav-right ml-auto">
            <div className="nav-item main-header-message ">
              <a
                className="new nav-link"
                href="https://sso.erdenetmc.mn/login"
                alt="sso login"
              >
                <i className="fe fe-user"></i>
              </a>
            </div>
            {state.isexternal === 0 && (
              <>
                <div className="nav-item main-header-message ">
                  <a
                    className="new nav-link"
                    href="https://web.erdenetmc.mn/link/phone/"
                  >
                    <i className="fe fe-phone"></i>
                  </a>
                </div>
                <div className="nav-item main-header-message ">
                  <a
                    className="new nav-link"
                    href="https://web.erdenetmc.mn/link/email/"
                    alt="Төрсөн өдөр"
                  >
                    <i className="fe fe-mail"></i>
                  </a>
                </div>
              </>
            )}

            <div
              className={
                setting
                  ? "dropdown  nav-item main-header-message show"
                  : "dropdown  nav-item main-header-message"
              }
            >
              <a
                className="new nav-link"
                href="/"
                onClick={(e) => toggleSetting(e)}
              >
                <i className="fe fe-settings" />
              </a>
              <div className="dropdown-menu">
                <Setting />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default React.memo(Header);
